<template>
  <Modal @close="onClose" title="データ移管を開始" noScroll staticFooter hideCloseButton>
    <template #content>
      <div class="modal-content">
        <div class="store-name">{{ baseGNo }} {{ baseStoreName }}</div>
        <p>のデータを移管してよろしいですか？</p>
        <p class="remarks">※すべてのデータが反映するまで30分ほどかかる場合があります</p>
      </div>
    </template>
    <template #footer-center>
      <Button @click="onClose" :disabled="busy">戻る</Button>
      <Button primary @click="onExectue" :disabled="busy">開始</Button>
    </template>
  </Modal>
</template>

<script>
import { mapState } from 'vuex'
import Button from '@/components/atoms/Button'
import Modal from '@/components/molecules/Modal'

export default {
  name: 'ExecuteModal',
  components: {
    Button,
    Modal,
  },
  data() {
    return {}
  },
  computed: {
    ...mapState({
      busy: state => state.storetransfer.execute.busy,
      token: state => state.storetransfer.auth.token,
      baseStoreName: state => state.storetransfer.auth.baseStoreName,
      baseGNo: state => state.storetransfer.auth.baseGNo,
    }),
  },
  methods: {
    async onExectue() {
      const { token } = this
      if (await this.$store.dispatch('storetransfer/execute/start', { token })) {
        // 画面をリロードして移管中画面を表示する
        location.reload()
      }
    },
    onClose() {
      this.$emit('close')
    },
  },
}
</script>

<style lang="postcss" scoped>
.modal {
  .header {
    height: auto;
  }
  .modal-content {
    display: grid;
    gap: 12px;
    justify-content: center;
    padding: 32px;
    text-align: center;

    .store-name {
      background-color: var(--very-light-gray-4);
      font-size: 21px;
      padding: 19px 16px 16px 16px;
    }

    .remarks {
      font-size: 11px;
      letter-spacing: 0;
    }
  }

  & >>> footer {
    border-top: none;
  }
}
</style>
